module.exports = __webpack_public_path__ + "img/map-3-f.8776f437.png";